/**
 * Email Us Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initEmailUs() {
        const blocks = document.querySelectorAll('.email-us');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] email-us block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEmailUs);
    } else {
        initEmailUs();
    }
})();